import { useState } from "react";
import { API } from "../api";

export function CGVAcceptance({ onAccepted }: { onAccepted: () => void }) {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function accept() {
    setLoading(true);
    setError(null);
    try {
      await API.acceptCGV("v1");
      onAccepted();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="xs-card" style={{ maxWidth: 560 }}>
      <h2>Bienvenue sur Xsavier</h2>
      <p className="xs-card-desc">
        L&apos;assistant SAV de Fourniresto. Avant de commencer, acceptez nos
        conditions de service.
      </p>
      <div style={{ fontSize: 13, color: "#475569", marginBottom: 16 }}>
        <p style={{ margin: "0 0 8px" }}>
          Le service SAV de Fourniresto est géré par <strong>Xsavier</strong>,
          un système d&apos;intelligence artificielle. Les décisions à enjeu élevé
          sont supervisées par un collaborateur humain.
        </p>
        <p style={{ margin: "0 0 8px" }}>
          Vous pouvez à tout moment demander à parler à un humain en utilisant
          le mot <em>« humain »</em> dans vos messages.
        </p>
        <p style={{ margin: 0, fontSize: 12, color: "#64748b" }}>
          Conformément au Règlement UE 2024/1689 (AI Act), vous avez le droit
          d&apos;être informé des décisions automatisées vous concernant.
        </p>
      </div>

      <label
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 8,
          cursor: "pointer",
          marginBottom: 16,
          fontSize: 14,
        }}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          style={{ marginTop: 3 }}
        />
        <span>J&apos;accepte ces conditions</span>
      </label>

      {error && <div className="xs-alert xs-alert-error">{error}</div>}

      <button
        className="xs-btn xs-btn-primary"
        disabled={!checked || loading}
        onClick={accept}
      >
        {loading ? "…" : "Continuer"}
      </button>
    </div>
  );
}
